import { AdminAppState, EventsState } from '../../state';

export const getEvents = (state: AdminAppState): EventsState => state.events;
